export default "__VITE_ASSET__a78d0083__"